import { combineReducers } from 'redux';
import approvedHourReducer from './approvedHourReducer';
import attributeReducer from './attributeReducer';
import customerReducer from './customerReducer';
import eventReducer from './eventReducer';
import floatingTaskReducer from './floatingTaskReducer';
import logEntryReducer from './logEntryReducer';
import customerGroupReducer from './customerGroupReducer';
import notificationReducer from './notificationReducer';
import projectReducer from './projectReducer';
import tashiReducer from './tashiReducer';
import taskReducer from './taskReducer';
import timeReducer from './timeReducer';
import timesheetReducer from './timesheetReducer';
import userReducer from './userReducer';
import userTaskReducer from './userTaskReducer';
import {routerReducer} from 'react-router-redux';
import weekApprovalUiReducer from "./weekApprovalUiReducer";
import contractReducer from "./contractReducer";

const rootReducer = combineReducers({
    approvedHours: approvedHourReducer,
    attributes: attributeReducer,
    customers: customerReducer,
    events: eventReducer,
    floatingTasks: floatingTaskReducer,
    customerGroups: customerGroupReducer,
    logEntries: logEntryReducer,
    notifications: notificationReducer,
    projects: projectReducer,
    tashi: tashiReducer,
    tasks: taskReducer,
    time: timeReducer,
    timesheets: timesheetReducer,
    users:userReducer,
    userTasks: userTaskReducer,
    weekApprovalUi: weekApprovalUiReducer,
    contracts: contractReducer,
    routing: routerReducer
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/app/reducers/index.js
 **/